import { CartTotalResponse } from '@diamond/shared/types';
import { formatDateRange } from '@diamond/shared/utils';

import { ItemInfo } from '../promos/promos';

type AppliedVoucher = NonNullable<CartTotalResponse['vouchers']> extends infer V
  ? V extends { applied_vouchers?: Array<unknown> }
    ? V['applied_vouchers'] extends Array<infer AV>
      ? AV
      : never
    : never
  : never;

export interface VoucherBannerData {
  type: 'free-item' | 'discount' | 'cashback';
  label: 'Gratis' | 'Diskon' | 'Cashback';
  text: string;
  dateRange: string;
  item?: ItemInfo;
  images?: string[];
  savings?: number;
  discountDisplay?: string;
  voucherCode: string;
  voucherId: string;
}

export const extractVoucherBannerData = (
  voucher: AppliedVoucher,
  cartItems?: Array<{
    product: { item_code: number; prices?: Array<{ price: number }> };
  }>
): VoucherBannerData | null => {
  if (!voucher.reward_type || voucher.reward_type !== 'FREE_GOODS') {
    return null;
  }

  if (!voucher.free_goods || voucher.free_goods.length === 0) {
    return null;
  }

  const allImages: string[] = [];
  voucher.free_goods.forEach((freeGood) => {
    const img =
      freeGood.product_image_thumbnails?.[0] ||
      freeGood.product_images_medium?.[0] ||
      freeGood.product_images?.[0];
    if (img) {
      allImages.push(img);
    }
  });

  const freeGood = voucher.free_goods[0];

  const dateRange =
    voucher.valid_from && voucher.valid_until
      ? formatDateRange(voucher.valid_from, voucher.valid_until)
      : '';

  const freeQty = freeGood.quantity / 1000;

  let price = 0;
  if (cartItems) {
    const cartItem = cartItems.find(
      (item) => item.product.item_code === freeGood.product_item_code
    );
    if (cartItem?.product.prices?.[0]?.price) {
      price = cartItem.product.prices[0].price / 1000;
    }
  }

  const savings = price > 0 ? price * freeQty : undefined;

  const item: ItemInfo = {
    id: freeGood.product_id || '',
    img: allImages[0] || '',
    price: price * 1000,
    qty: freeQty,
    uom: '',
  };

  const text = `Voucher ${voucher.voucher_code}: Gratis ${freeQty} ${freeGood.product_name}`;

  return {
    type: 'free-item',
    label: 'Gratis',
    text,
    dateRange,
    item,
    images: allImages.length > 0 ? allImages : undefined,
    savings,
    voucherCode: voucher.voucher_code,
    voucherId: voucher.voucher_id,
  };
};
